import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 
import React from "react";
// import "../pages/Interactions/AddInteractions"

const Interactionlist = lazy(() => import("../pages/Interactions/Interactionlist"));
const AddInteractions = lazy(() => import("../pages/Interactions/AddInteractions"));
const Interactiondetails = lazy(() => import("../pages/Interactions/Interactiondetails"));
const Responsedetails = lazy(() => import("../pages/Interactions/Responsedetails"));
const Addresponsedetails = lazy(() => import("../pages/Interactions/Addresponsedetails"));
const Documents = lazy(() => import("../pages/Interactions/Documents"));
const Linkedrecords = lazy(() => import("../pages/Interactions/LinkedRecords"));



const HAInteractionList = lazy(() => import("../pages/hainteractions/HAInteractionList"));
const HAInteractionEdit = lazy(() => import("../pages/hainteractions/HAInteractionEdit"));
const HAInteractionAdd = lazy(() => import("../pages/hainteractions/HAInteractionAdd"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/Interactions" />
    ),
  },
  {
    path: "/hainteractions",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <HAInteractionList />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  {
    path: "/hainteractions/edit-ha",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
           <HAInteractionEdit /> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/hainteractions/add-ha",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
         <HAInteractionAdd/> 
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/Interactions",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Interactionlist />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/Interactions/AddInteractions",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddInteractions />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  {
    path: "/Interactions/Interactiondetails",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Interactiondetails />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/Interactions/Documents",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Documents />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/Interactions/Linkedrecords",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Linkedrecords />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/Interactions/Responsedetails",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Responsedetails />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  {
    path: "/Interactions/Addresponsedetails",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Addresponsedetails />
        </Suspense>
      </ErrorBoundary>
    ),
  },





];

const Router = createBrowserRouter(routesForm);

export { Router };